import styled, {css} from 'styled-components';

import {InfoDropdownOverlay, ModalContent} from '@edna/components';
import {
  ModalActions as BaseModalActions,
  ModalHeader as BaseModalHeader,
} from '@edna/components/Modals/Modal';
import {NewNumberInputField as BaseNumberInputField} from '@edna/components/NumberInput';
import {Icon} from '@edna/components/primitives';
import {mixins} from '@edna/components/styles';

import {ModalCenterImage as BaseModalCenterImage} from 'src/components/primitives';
import {
  DownloadIcon as BaseDownloadIcon,
  StripeLogoIcon as BaseStripeLogoIcon,
  CoinsIcon,
} from 'src/icons';

export const OptionIcon = styled.svg`
  margin-right: ${({theme}) => theme.spacing.s4};
`;

export const ButtonLeftIcon = styled(Icon)`
  margin-right: ${({theme}) => theme.spacing.s1};
`;

export const Currency = styled.div<{hasMargin?: boolean}>`
  max-height: max-content;
  margin-top: ${({theme, hasMargin}) => (hasMargin ? theme.spacing.s9 : 0)};
`;

export const StripeLogoIcon = styled(BaseStripeLogoIcon)`
  display: block;
  ${mixins.wh('60px', '25px')}
`;

export const StripeModalHeader = styled(BaseModalHeader)`
  ${mixins.stack({size: '1', justify: 'center', align: 'center'})}
`;

export const NestedBlock = styled.div`
  ${mixins.stack({size: '4'})}
  width: 100%;
  padding-left: ${({theme}) => theme.spacing.s7};
`;

export const PayKeeperNumberInputField = styled(BaseNumberInputField)`
  width: 100px;
  margin: 0;
`;

export const PayKeeperModalContent = styled(ModalContent)`
  ${mixins.stack({size: '4'})}
`;

export const NumberInputField = styled(BaseNumberInputField)`
  max-width: 160px;
`;

export const ModalCenterImage = styled(BaseModalCenterImage)`
  color: ${({theme}) => theme.branding.colors.accentB};
`;

export const DownloadIcon = styled(BaseDownloadIcon)`
  ${mixins.wh('20px')}
  display: inline-block;
  margin-right: ${({theme: {spacing}}) => spacing.s1};
`;

export const Row = styled.div`
  ${mixins.stack({size: '2', direction: 'ROW'})}
  ${({theme}) => css`
    margin-top: ${theme.spacing.s3};
  `}
`;

export const ModalHeader = styled(BaseModalHeader)`
  ${mixins.stack({size: '1', justify: 'center', align: 'center'})}
`;

export const CenterModalActions = styled(BaseModalActions)`
  ${mixins.flexAlign('center')}
`;

export const Wrapper = styled.div`
  ${mixins.stack({size: '4'})};
  margin-bottom: ${({theme}) => theme.spacing.s4};
`;

export const SecondaryCoinsIcon = styled(Icon).attrs({as: CoinsIcon, size: '20px'})`
  color: ${({theme}) => theme.branding.content.tertiary};
  margin: ${({theme}) => `0 ${theme.spacing.s1} ${theme.spacing.s1} 0`};
`;

export const HintOverlay = styled(InfoDropdownOverlay)`
  ${mixins.position({position: 'absolute', top: '-50%', left: 'calc(100% + 12px)'})}
  width: 250px;

  &::before {
    ${mixins.position({
      position: 'absolute',
      bottom: '100%',
      right: '100%',
      top: '26px',
      left: '-4px',
      transform: 'rotate(-135deg)',
    })}
  }
`;
